import * as constants from './constants';

const initialState = {
  allStickers: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const learningActivityStickersReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_SITE_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_SITE_STATUSES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allStickers: [...state.allStickers, action.data],
        isAdding: false,
      };
    case constants.CREATE_SITE_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER_SITE_STATUS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_SITE_STATUS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allStickers: action.data,
      };
    case constants.UPDATE_ORDER_SITE_STATUS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_SITE_STATUSES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_SITE_STATUSES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allStickers: action.data,
        isAdding: false,
      };
    case constants.FETCH_SITE_STATUSES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_SITE_STATUSES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false
      };
    case constants.UPDATE_SITE_STATUSES_SUCCESS:
      const updated = state.allStickers.map((el) =>
        el._id === action.data._id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allStickers: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_SITE_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_SITE_STATUSES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_SITE_STATUSES_SUCCESS:
      const updatedData = state.allStickers.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allStickers: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_SITE_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default learningActivityStickersReducer;
